import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateUtilService } from '../../../shared/services/date-util.service';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { SolicitePedidoService } from './solicite-pedido-pre-pago.service';
import { NotificationsService } from 'angular2-notifications';
import { NbDialogService } from '@nebular/theme';
import { ModalPagamentoComponent } from './modal-pagamento/modal-pagamento.component';
import { ModalAvisoComponent } from './modal-aviso/modal-aviso.component';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { ExportExcelService } from '../../../shared/services/export-excel.service';
import { CommonService } from '../../../shared/services/commom.service';
import { CentroCustoService } from '../../gestao-plano-viagem/plano-viagens/centro-custo/centro-custo.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';

@Component({
  selector: 'ngx-solicite-pedido-pre-pago',
  templateUrl: './solicite-pedido-pre-pago.component.html',
  styleUrls: ['./solicite-pedido-pre-pago.component.scss']
})
export class SolicitePedidoPrePagoComponent implements OnInit {

  public form = null;
  public rowData = [];
  public rowData2 = []
  public tableLimit = 20;
  public listStatus = null;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
  public listCentroCusto = [];
  public type = null;
  public blob = null;
  public b64Data = null;
  public customLogin = null;
  public isProdutoMigrado: boolean = false;

  public dataFim = '';
  public dataInicio = '';
  public today = new Date();
  public dateInicio = new Date(new Date().setDate(this.today.getDate() - 600));
  public columnsTabe = null;
  public exportTotal = null;
  check;
  checkeds = [];
  checkedsObjs = [];
  cancelar = true;
  square = false;
  checkboxArray = [];
  public addRow = false;

  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    showClearDateBtn: false,
    openSelectorOnInputClick: true,
    showTodayBtn: false,
    allowSelectionOnlyInCurrentMonth: false,
    dayLabels: { su: "Dom", mo: "Seg", tu: "Ter", we: "Qua", th: "Qui", fr: "Sex", sa: "Sab" },
    monthLabels: { 1: "Jan", 2: "Fev", 3: "Mar", 4: "Abr", 5: "Mai", 6: "Jun", 7: "Jul", 8: "Ago", 9: "Set", 10: "Out", 11: "Nov", 12: "Dez" },
    firstDayOfWeek: "su",
    //disableUntil: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() - 1 }
  };

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private spinnerService: NgxSpinnerService,
    private service: SolicitePedidoService,
    private paginationService: SpringDatatablePaginationService,
    private dateUtilService: DateUtilService,
    private notificationService: NotificationsService,
    private dialogService: NbDialogService,
    private exportCsvService: ExportCsvService,
    private exportExcelService: ExportExcelService,
    private commomService: CommonService,
    private centroCustoservice: CentroCustoService,
    private encriptyService: EncriptyUtilService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.listStatus = [
      {
        status: 'SOLICITADO',
        descricao: 'SOLICITADO'
      },
      {
        status: 'GERADO',
        descricao: 'GERADO'
      },
      {
        status: 'COMPENSADO',
        descricao: 'COMPENSADO'
      },
      {
        status: 'CANCELADO',
        descricao: 'CANCELADO'
      },
      {
        status: 'PROCESSANDO',
        descricao: 'PROCESSANDO'
      },
      {
        status: 'EMITIDO',
        descricao: 'EMITIDO'
      },
      {
        status: 'ERRO_EMISSAO',
        descricao: 'ERRO_EMISSAO'
      },
      {
        status: 'ERRO_SOLICITACAO',
        descricao: 'ERRO_SOLICITACAO'
      },
      {
        status: 'ERRO_GERACAO',
        descricao: 'ERRO_GERACAO'
      },
      {
        status: 'CRIADO',
        descricao: 'CRIADO'
      },
      {
        status: 'ERRO_CRIACAO',
        descricao: 'ERRO_CRIACAO'
      },
    ];

    this.columnsTabe = [
      { columnName: "dataSolicitado", newColumnName: "Data de Solicitação" },
      { columnName: "dataBaixa", newColumnName: "Data da Baixa" },
      { columnName: "vencimento", newColumnName: "Data Vencimento" },
      { columnName: "valor", newColumnName: "Valor" },
      { columnName: "formaPagamento", newColumnName: "Forma Pagamento" },
      { columnName: "numeroPedido", newColumnName: "Número" },
      { columnName: "status", newColumnName: "Situação" },
      { columnName: "centroCusto", newColumnName: "Centro de Custo"}
    ]
  }


  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.form = this.formBuilder.group({
      status: [null],
      dataFim: [null],
      dataInicio: [null],
      centroCusto:[null]
    });

    this.buscarPedido();
    this.usuarioPermitido(['BACKOFFICE']);
    this.buscarCentrosCusto();
    this.verificarMigracaoRollout();

  }

  public isUserAllowed: boolean;

  usuarioPermitido(data){
    let params = new HttpParams();

    data.forEach(item =>{
      params=params.append('profilesNotAllowed',String(item))
    })

    this.spinnerService.show();
    this.commomService.isUserAllowed(params,
      res => {
        this.isUserAllowed = res;
        this.spinnerService.hide();
      },
      err => {
        this.spinnerService.hide();
        this.notificationService.error(err.message);
      }
    )

  }


  private buildParams(data: any, page?: number, size: string = String(this.tableLimit)): HttpParams {
    let params = new HttpParams().set('size', size);

    if (page) {
      params = params.set('page', String(page));
    }

    if (data) {
      if (!data.dataInicio || !data.dataFim) {
        this.notificationService.warn("Atenção!", "Datas de início e fim obrigatórias.");
        return null;
      }
      params = this.addDateParam(params, 'dataInicio', data.dataInicio);
      params = this.addDateParam(params, 'dataFim', data.dataFim);
      if (![null, 'null'].includes(data.status)) {
        params = params.set('status', data.status);
      }
      if (![null, 'null'].includes(data.centroCusto)){
        params = params.set('centroDeCusto', data.centroCusto);
      }
    } else {
      const prev7Days = moment().subtract(7, "days");
      const currentDay = moment();
      this.form.controls['dataInicio'].setValue({date: {year: prev7Days.year(),month: prev7Days.month() + 1,day: prev7Days.date()},epoc: prev7Days.unix(),formatted: prev7Days.format('DD/MM/YYYY'),jsdate: prev7Days.toDate()});
      this.form.controls['dataFim'].setValue({date: {year: currentDay.year(),month: currentDay.month() + 1,day: currentDay.date()},epoc: currentDay.unix(),formatted: currentDay.format('DD/MM/YYYY'),jsdate: currentDay.toDate()});
      params = params
        .set('dataInicio', prev7Days.format("YYYY-MM-DD"))
        .set('dataFim', currentDay.format("YYYY-MM-DD"));
    }
    return params;
  }

  private addDateParam(params: HttpParams, key: string, dateValue: any): HttpParams {
    if (dateValue) {
      const date = this.dateUtilService.datepickerTransformDate(dateValue, 'YYYY-MM-DD');
      return params.set(key, date);
    }
    return params;
  }

  private mapPedidoData(data: any, formatDates: boolean = false, removeId:boolean = false) {
    let mapped = {
      dataSolicitado: formatDates ? moment(data.dataSolicitado).format('DD/MM/YYYY') : data.dataSolicitado,
      dataBaixa: formatDates && data.dataBaixa ? moment(data.dataBaixa).format('DD/MM/YYYY') : data.dataBaixa,
      vencimento: formatDates && data.vencimento ? moment(data.vencimento).format('DD/MM/YYYY') : data.vencimento,
      valor: data.valor,
      formaPagamento: data.formaPagamento,
      numeroPedido: data.numeroPedido,
      centroCusto: (data.codigoCentroDeCusto ? data.codigoCentroDeCusto : "" ) + " - " + (data.descricaoCentroDeCusto ? data.descricaoCentroDeCusto : "" ),
      status: data.status,
      id: data.id,
      faturas: data.faturas || []
    };

    if (removeId) {
      delete mapped.id;
    }

    return mapped;
  }

  buscarPedido(data: any = null, page?: any, typeEvent?: string) {
    console.log(typeEvent)
    const params = this.buildParams(data, page);
    if (params==null) return;

    this.spinnerService.show();
    this.service.prepaidOrderSearch(params, (response => {
      if (response.content.length === 0) {
        this.notificationService.warn("Atenção!", "Sem dados para exibição.");
      }
      this.rowData = response.content.map(item => this.mapPedidoData(item));

      this.paginationService.setInfo(response);

      setTimeout(() => {
        const checkboxes: any = document.getElementsByName('notifcheck');
        checkboxes.forEach(element => {
          element.checked = this.check || this.checkboxArray.includes(Number(element.id));
        });
        this.spinnerService.hide();
      }, 1500);

    }), (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });
  }

  buscarPedidoTotal(data?: any) {
    if (this.exportTotal != null) {
      const params = this.buildParams(data, undefined, '1999999999');
      this.spinnerService.show();

      this.service.prepaidOrderSearch(params, (response => {
        if (response.content.length === 0) {
          this.notificationService.warn("Atenção!", "Sem dados para exibição.");
        }

        this.rowData2 = response.content.map(item => this.mapPedidoData(item, true, true));

        this.exportExcelService.exportXlsx(this.rowData2, this.columnsTabe, 'Pedidos');
        setTimeout(() => this.spinnerService.hide(), 1500);

      }), (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      });

    } else {
      const formatDates = this.addRow === true;
      this.rowData2 = this.rowData2.map(item => this.mapPedidoData(item, formatDates));

      this.exportExcelService.exportXlsx(this.rowData2, this.columnsTabe, 'Pedidos');
      setTimeout(() => this.spinnerService.hide(), 1500);
    }
  }

  geraPedido() {

    this.router.navigate(['/pages/boleto-pre-pago/gera-pedido-pre-pago']);

  }

  openPdf(pdfB64) { }

  pdfBlobConversion(b64Data, contentType) {

    contentType = contentType || '';
    var sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    var byteCharacters = window.atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset = offset + sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });

    return blob;

  }

  gotoVisualizar(data) {

    this.dialogService.open(ModalPagamentoComponent, {
      context: {
        paymentData: data,

      },
    })
  }


  gotoVisualizarNF(fatura) {
    let params = new HttpParams();

    var type = 'application/pdf';
    let blob = null;

    if (!fatura || !fatura.faturaId) {
      return;
    }

    params = params.append('idAps', fatura.faturaId)
    //params = params.append('cToken', '5ee45af42ed50678f74d286ecac32ce50dfe1d0f604502ec940840433b8ff26f')

    this.spinnerService.show();

    this.service.getDanfePdf(params, (response) => {

      this.spinnerService.hide();

      if (response.status == 'N') {
        this.notificationService.error("Nota ainda não disponivel, tente novamente mais tarde.");
        return;
      }

      this.b64Data = response.response;

      const blobURL = URL.createObjectURL(this.pdfBlobConversion(this.b64Data, 'application/pdf'));
      const theWindow = window.open(blobURL);
      const theDoc = theWindow.document;
      const theScript = document.createElement('script');
      function injectThis() {
        window.print();
      }
      theScript.innerHTML = 'window.onload = ${injectThis.toString()};';
      theDoc.body.appendChild(theScript);

    }, (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });

  }

  gotoAprovacao(data: any) {

    this.dialogService.open(ModalPagamentoComponent, {
      context: {
        paymentData: data,

      },
    })
  }

  cancelaPedido(data: any) {

    this.spinnerService.show();
    this.service.deletePedido(data.numeroPedido, (response => {
      // this.rowData = response.content
      // this.paginationService.setInfo(response);
      this.spinnerService.hide();
      this.notificationService.success("Sucesso!", "Pedido cancelado.");
      this.buscarPedido(this.form.value.dataInicio != null && this.form.value.data != null ? this.form.value : null);
    }), (error) => {
      this.spinnerService.hide();
      this.notificationService.error(error.message);
    });
  }


  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }


  exportCsv() {
    this.exportCsvService.exportCsv(this.rowData, null, ';', 'Pedidos');
  }

  desmarcarTodos(row) {

    this.checkeds = [];
    this.rowData2 = [];
    this.checkboxArray = [];
    this.check = false;

    const checkboxes: any = document.getElementsByName('notifcheck');
    checkboxes.forEach(element => {
      element.checked = this.check;
    });

  }

  selecionarTodos(event) {

    this.exportTotal = 'total'
    this.checkeds = [];
    this.check = !this.check;

    if (this.check) {
      this.rowData2 = this.rowData
    }

    const checkboxes: any = document.getElementsByName('notifcheck');

    checkboxes.forEach(element => {
      element.checked = true;
    });

  }

  cleanCancelar() {
    this.checkeds = [];
    this.check = false;
    this.cancelar = false;
    this.square = true;
  }

  selectCheck(event, element) {
    this.exportTotal = null;

    let DX = this.rowData2.findIndex(el => el.numeroPedido === element.numeroPedido)
    let DX2 = this.checkboxArray.findIndex(el => el === element.id)

    if (!event.target.checked) {
      this.addRow = false;
      this.checkboxArray.splice(DX2, 1)
      this.rowData2.splice(DX, 1)
    } else {
      this.addRow = true;
      this.checkboxArray.push(element.id)
      this.rowData2.push(element)
    }

  }


   buscarCentrosCusto() {
    let params = new HttpParams();
    params = params.append('status', 'ATIVO');

    this.spinnerService.show();

    this.centroCustoservice.buscaCentrosCusto(params,
      (response) => {
        this.listCentroCusto = response.content;
        this.spinnerService.hide();
      },
      (error) => {
        this.spinnerService.hide();
        this.notificationService.error(error.message);
      }
    );
  }

  verificarMigracaoRollout() {
    this.commomService.isProdutoMigrado().subscribe(isMigrated => {
      this.isProdutoMigrado = isMigrated;
      if (this.isProdutoMigrado) {
        this.dialogService.open(ModalAvisoComponent, {
          context: {
            titulo: 'Aviso importante',
            mensagem: '<h6><b>Seu saldo global atual não será transferido para o Novo Portal.</b></h6><br>Para evitar saldo parado,<b> utilize todo o valor </b> disponível e evite novos pedidos. ' +
            'Estamos realizando a migração para o Novo Portal. Por isso, as novas cargas de saldo deverão ser realizadas no novo ambiente para que a gestão dos benefícios continue ocorrendo normalmente.'
          }
        });
      }
    });
  }

}
